/* eslint-disable jira/filename-case */
export const HELP_PANEL_UI_STORAGE_KEY = 'help_panel_ui_state';
